import React from "react";
import { PrimaryButton } from "@fluentui/react";
import { ButtonVariants } from "../../../styles/fluent/ButtonVariants";
import { formatMessage, formatMessageWithParams } from "../../../utils/helpers/LanguageHelper";

interface ObjectsListDeleteFooterProps {
  disabled?: boolean;
  onDelete: () => void;
  count?: number;
}

export const ObjectsListDeleteFooter: React.FC<ObjectsListDeleteFooterProps> = (props) => {
  const { disabled, onDelete, count } = props;

  return (
    <PrimaryButton
      id="delete_button"
      disabled={disabled}
      className={ButtonVariants.red_filled}
      styles={{
        label: { whiteSpace: "nowrap" },
      }}
      onClick={onDelete}
      text={
        count !== undefined && !disabled
          ? formatMessageWithParams("cof.base.deletecount", { count: count }).toUpperCase()
          : formatMessage("cof.base.delete").toUpperCase()
      }
    />
  );
};
